import { GTMolecularExportFn } from "../../components/GTMolecularExportFn";

const FN_NAME = "gtm-export-kit-assay-assignments";

function FnRun() {
  return <GTMolecularExportFn name={FN_NAME} />;
}

export { FnRun };
